(function() { module.exports = window["wp"]["components"]; }());